import { render, staticRenderFns } from "./AscReportDetailsTemplate.vue?vue&type=template&id=8b5116b2&"
import script from "./AscReportDetailsTemplate.vue?vue&type=script&lang=js&"
export * from "./AscReportDetailsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscReportDetailsTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports